(function () {
  function uniqKeyFromName(name) {
    // name looks like properties[Farve 1]
    return name || "";
  }

  function findProductFormFromButton(btn) {
    // Tinker uses <product-form-component> and the real <form> is inside it
    const pfc = btn.closest("product-form-component") || document.querySelector("product-form-component");
    if (!pfc) return null;
    return pfc.querySelector("form");
  }

  function collectPickerInputsNear(btn) {
    // Look for pickers near the clicked button (same product info area).
    // Fallback to any on page.
    const scope =
      btn.closest(".product-information") ||
      btn.closest(".product") ||
      btn.closest("main") ||
      document;

    const pickers = scope.querySelectorAll(".homae-colorpicker");
    const inputs = [];
    pickers.forEach((picker) => {
      picker.querySelectorAll('input[name^="properties["]').forEach((inp) => {
        inputs.push(inp);
      });
    });

    // If nothing found in scope, try global
    if (!inputs.length) {
      document.querySelectorAll('.homae-colorpicker input[name^="properties["]').forEach((inp) => inputs.push(inp));
    }

    return inputs;
  }

  function injectIntoForm(form, inputs) {
    if (!form || !inputs || !inputs.length) return;

    // Remove previously injected inputs (avoid duplicates)
    form.querySelectorAll("[data-homae-injected='true']").forEach((n) => n.remove());

    inputs.forEach((inp) => {
      // clone value into the real form
      const clone = inp.cloneNode(true);
      clone.setAttribute("data-homae-injected", "true");

      // only inject meaningful values (optional):
      // if you want empty selections to still show, remove this if-block
      if ((clone.value || "").trim() === "") return;

      // If same property key exists, replace it
      const key = uniqKeyFromName(clone.getAttribute("name"));
      const existing = form.querySelector(`input[name="${CSS.escape(key)}"]`);
      if (existing) existing.remove();

      form.appendChild(clone);
    });
  }

  function handleAddToCartClick(e) {
    const btn = e.target.closest('button[type="submit"][name="add"], button[type="submit"].add-to-cart-button');
    if (!btn) return;

    const form = findProductFormFromButton(btn);
    if (!form) return;

    const inputs = collectPickerInputsNear(btn);
    injectIntoForm(form, inputs);
  }

  // Click handler (most reliable for Tinker’s button)
  document.addEventListener("click", handleAddToCartClick, true);

  // Also hook submit (fallback)
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form || form.tagName !== "FORM") return;
      // Only target product forms
      const isProductForm = form.closest("product-form-component");
      if (!isProductForm) return;

      const inputs = collectPickerInputsNear(form);
      injectIntoForm(form, inputs);
    },
    true
  );
})();
